module.exports = __webpack_public_path__ + "img/offline.9008ce86.png";